import type { AsyncStatus, Queue, QueueStateT } from 'lib-shared-legacy-types';
import _orderBy from 'lodash/orderBy';
import { createSelector } from 'reselect';

import type { RootReducerStateT } from 'app/reducers/rootReducer';
import type { LanguageT } from 'components/powerCallFlow/reducers/flowLanguages';

const getFlowLanguages = (state: RootReducerStateT): LanguageT[] =>
  state.flowLanguages.languages;

export const getLastUsedEmailIntegration = (
  state: RootReducerStateT,
): string | null => state.settings.personal.lastUsedEmailIntegration;

const getQueues = (state: RootReducerStateT): Queue[] =>
  state.settings.queues.queues as any;

const getQueuesAsyncStatus = (state: RootReducerStateT): AsyncStatus =>
  state.settings.queues.asyncStatus;

/* SELECTORS */
export const selectFlowLanguagesSorted = createSelector(
  getFlowLanguages,
  (languages: LanguageT[]): LanguageT[] =>
    _orderBy(
      languages,
      [(language: LanguageT) => language.label.toLowerCase()],
      'asc',
    ),
);

export const selectSortedQueuesByName = createSelector(
  getQueues,
  (queues: Queue[]) =>
    _orderBy(queues, [(queue: Queue) => queue.name.toLowerCase()], ['asc']),
);

export const selectQueueState = createSelector(
  [selectSortedQueuesByName, getQueuesAsyncStatus],
  (queues: Queue[], asyncStatus: AsyncStatus): QueueStateT => ({
    queues,
    asyncStatus,
  }),
);

export const selectSortedQueuesByPriorityAndName = createSelector(
  getQueues,
  (queues: Queue[]): Queue[] =>
    _orderBy(
      queues,
      [
        (queue: Queue): number | null => queue.priority,
        (queue: Queue): string => queue.name.toLowerCase(),
      ],
      ['asc', 'asc'],
    ),
);
